import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\@next\\third-parties\\dist\\google\\ga.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\@next\\third-parties\\dist\\google\\gtm.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\@next\\third-parties\\dist\\ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.js\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"rubik\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\CookieBanner\\CookieBanner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\krrsw\\development\\skylang\\src\\components\\Header\\Header.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\globals.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\Footer.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\SocialMediaLinks.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\krrsw\\development\\skylang\\src\\styles\\components\\MessageUs.css");
